export const TOKEN = 'jweToken'
export const SECURITY_CERTIFY_TOKEN = 'token'
export const HELP_URL = import.meta.env.VITE_APP_HELP_URI

export const TIME_UNIT_HOURS_SECONDS = 3600
export enum DiplomaArr {
  PhD = '博士',
  master = '硕士',
  Undergraduate = '本科',
  specialist = '专科',
  other = '其他',
}
export enum Scenes {
  Gpu = 'Gpu',
  Game = 'Game',
  App = 'App',
  Generic = 'Generic',
  Desktop = 'Desktop',
  Ebusiness = 'E-business',
}

export enum ScenesName {
  Gpu = 'GPU 实例',
  App = '镜像应用',
  Game = '云游戏',
  Generic = 'CPU 实例',
  Desktop = '云桌面',
  Ebusiness = '跨境电商',
  'E-business' = '跨境电商',
}
export enum ScenesKey {
  '云游戏' = 'Game',
  'GPU' = 'Gpu',
  '镜像应用' = 'App',
  'CPU 实例' = 'Generic',
  '桌面版' = 'Desktop',
  '电商版' = 'Ebusiness',
}

export type SceneValueType = `${Scenes}`
export type SceneKeyType = `${Scenes}`

export enum PAY_METHOD_ENUM {
  USAGE = 'Usage',
  HOUR = 'Hour',
  DAY = 'Day',
  WEEK = 'Week',
  MONTH = 'Month',
}
export enum FormatType {
  usage = 'Usage',
  hour = 'Hour',
  day = 'Day',
  week = 'Week',
  month = 'Month',
}
export enum FormatPayMethod {
  Usage = '按时',
  Hour = '按时',
  Day = '包天',
  Week = '包周',
  Month = '包月',
}
export enum FormatPayDuration {
  Usage = '小时',
  Hour = '小时',
  Day = '天',
  Week = '周',
  Month = '月',
}
export const enum METHODS {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  PATCH = 'PATCH',
}

export enum GpuTypeName {
  Personal = 'Personal',
  Enterprise = 'Enterprise',
}
export type GpuKeyTypeName = keyof typeof GpuTypeName

export const enum PATH {
  HOME = '/',
  LOGIN = '/login',
  REGISTER = '/register',
  RDP = '/rdp',
  CONSOLE = '/console',
  STATIC = '/stats',
  GAME = '/stats/game',
  CENTER = '/console/center',
  // 云产品
  CLOUD = '/stats/cloud',
  GPU = '/stats/cloud/gpu',
  APPLY = '/stats/cloud/apply',
  PURCHASE = '/stats/purchase',
  ENTERPRISE = '/console/enterprise',
  PERSONAL = '/console/personal',
  BASE = '/console/base',
  GENERIC = '/console/generic',
  ACCOUNT = '/console/account',
  IPVMDETAIL = '/console/ipvm/detail',

  IMAGESHARE = '/image/share',
  THIRDLOGIN = '/upyunLogin',
  /*** Ai 平台 */
  // 推理
  SD = '/sd',
  DIFFUSION = '/sd/diffusion',
  TRAIN = '/sd/train',
  DATA_SET = '/sd/dataset',
  CREATE_DATA_SET = '/sd/dataset/create',
  DETAIL_DATA_SET = '/sd/dataset/detail',
  UPLOAD_IMAGE_SET = '/sd/dataset/detail/upload',
  //算力中心
  COMPUTE = '/compute',
  COMPUTE_DETAIL = '/compute/detail',
  COMPUTE_CENTER = '/compute/center',
  COMPUTER_COMBO = '/compute',
  WORKFLOW = '/comfyui',
  //充值订单页
  FINANCE = '/finance',
  // 我的机器
  APPARATUS = '/apparatus',
  GPU_GENERIC = '/console/gpu-generic',
  GPU_APPLICATION = '/console/app',
  APPARATUS_GAME = '/console/game',
  APPARATUS_GENERIC = '/console/generic',
  APPARATUS_DESKTOP = '/console/desktop',
  APPARATUS_E_BUSINESS = '/console/e-business',
  LOG = '/console/log',
  // GPU数据
  GPU_DATA = '/gpudata',
  MIRROR = '/console/gpudata/mirror',
  DATA_DISK = '/console/gpudata/disk',
  // 费用
  COST = '/cost',
  COST_BILL = '/console/cost/bill',
  COST_BILL_STORAGE_DETAIL = '/console/cost/bill/storage-details',
  COST_BILL_SERVER_DETAIL = '/console/cost/bill/server-details/',
  COST_COUPON_PACKAGE = '/console/cost/coupon',
  COST_DEPOSIT = '/console/cost/deposit',
  COST_BILL_MODEL_DETAIL = '/console/cost/bill/model-details',
  COST_RESOURCE = '/console/cost/resource',
  // 充值
  RECHARGE = '/console/recharge',
  // 大模型服务
  MODEL = '/model',
  MODEL_SQUARE = '/model/square',
  MODEL_SQUARE_DETAIL = '/model/square/detail/:modelName',
  MODEL_EXPERIENCE = '/model/experience',
  MODEL_STATS = '/model/stats',
  MODEL_KEY = '/model/key',
  MODEL_IMAGE_GENERATOR = '/model/image-generator',
  MODEL_VIDEO_GENERATOR = '/model/video-generator',
  MODEL_COST = '/model/cost',
}

// 支付成功跳转
export enum SCENE_ROUTER_PATH {
  Gpu = PATH.GPU_GENERIC,
  App = PATH.GPU_APPLICATION,
  Game = PATH.APPARATUS_GAME,
  Generic = PATH.APPARATUS_GENERIC,
  Desktop = PATH.APPARATUS_DESKTOP,
  'E-business' = PATH.APPARATUS_E_BUSINESS,
  Computer = PATH.COMPUTE_CENTER,
}
export const enum CERT_TYPES {
  Uncertified = 'Uncertified',
  Personal = 'Personal',
  Enterprise = 'Enterprise',
}

export enum CERT_STATUS_TYPE {
  INIT = 'Init',
  PENDING = 'Pending',
  SUCCEED = 'Succeed',
  FAILED = 'Failed',
}
export enum CERT_STATUS {
  Init = '',
  Pending = '审核中',
  Succeed = '已认证',
  Failed = '认证失败',
}

export const enum LIMIT {
  IMAGEMAX = 512, // 头像大小限制 KB
}

export const IPVM_STATUS_TYPE = {
  PENDING: 'Pending',
  PENDING_MIGRATE: 'Pending_Migrate', // 数据迁移中
  STARTING: 'Starting',
  RUNNING: 'Running',
  STOPPED: 'Stopped',
  SHUTDOWNING: 'Shutdowning',
  SHUTDOWN: 'Shutdown',
  RESTARTING: 'Restarting',
  STOPPING: 'Stopping',
  OPERATING: 'Operating',
  UNKNOWN: 'Unknown',
  FAILED: 'Failed',
  DELETING: 'Deleting',
}
export enum IPVM_STATUS {
  Pending = '创建中',
  Starting = '启动中',
  Pending_Migrate = '数据迁移中',
  Running = '运行中',
  Stopped = '已关机',
  Shutdowning = '关机中（无卡模式）',
  Shutdown = '已关机（无卡模式）',
  Restarting = '重启中',
  Stopping = '关机中',
  Operating = '操作中',
  Unknown = '未知状态',
  Failed = '创建失败',
  Deleting = '销毁中',
  OperateFail = '操作失败',
}

export enum ORDER_KIND {
  NewBuy = 'NewBuy',
  Renew = 'Renew',
  Usage = 'Usage',
  Refund = 'Refund',
  OrderRefund = 'OrderRefund',
  TrafficUpgrade = 'TrafficUpgrade',
  TrafficDowngrade = 'TrafficDowngrade',
  DayToMonth = 'DayToMonth',
  TransferToLong = 'TransferToLong',
  Time = 'Time',
  ChangeDataDisk = 'ChangeDataDisk',
}

export enum ORDER_KIND_NAMES {
  NewBuy = '新购',
  Renew = '续费',
  Usage = '按时',
  Refund = '退款',
  OrderRefund = '订单退款',
  TrafficUpgrade = '流量升配置',
  TrafficDowngrade = '流量降配置',
  DayToMonth = '包天转包月',
  TransferToLong = '转长租',
  Time = '计时',
  ChangeDataDisk = '扩容数据盘',
}

export enum ORDER_STATUS {
  Unpaid = 'Unpaid',
  Paid = 'Paid',
  Success = 'Success',
  Failed = 'Failed',
  Expired = 'Expired',
  Cancelled = 'Cancelled',
  Refunded = 'Refunded',
  Time = 'Time',
}

export enum ORDER_STATUS_NAME {
  Unpaid = '待支付',
  Paid = '已支付',
  Success = '已完成',
  Failed = '处理失败',
  Expired = '已过期',
  Abated = '已失效',
  Cancelled = '已取消',
  Refunded = '已退款',
  Time = '计费中',
}
export enum ORDER_STATUS_COLOR {
  Unpaid = '#ff4d4f',
  Paid = '#52c41a',
  Success = '#52c41a',
  Failed = '#ff4d4f',
  Expired = '#898989',
  Abated = '#898989',
  Cancelled = '#898989',
  Refunded = '#ff4d4f',
  Time = '#7828FF',
}

export enum PAY_TYPE {
  Balance = '余额',
  Alipay = '支付宝',
  Wechat = '微信',
}
//  支付类型
export enum PAY_TYPE_ENUM {
  ALIPAY = 'Alipay',
  WE_CHAT = 'Wechat',
  BALANCE = 'Balance',
}

export const THIRD_URL = 'upyunLogin'

export enum ACCOUNT_QUERY_NAME {
  ACCOUNT_INFO = 'accountInfo',
  SECURITY_SETTING = 'securitySetting',
  CHECK_INFO = 'checkInfo',
  DEPOSIT = 'deposit',
}

// 镜像 保存状态
export enum IMAGE_STATUS_TYPE_ENUM {
  ACTIVE_NOT_ALLOWED_MIGRATE = 'Active_NotAllowedMigrate', // 不能迁移
  ACTIVE = 'Active', // 保存成功
  BUILD_FAIL = 'BuildFail', // 保存失败的
  BUILD = 'Build', // 打包中的
  MIGRATE = 'Migrate', //迁移中
}
export enum EXTERNAL_LINK {
  CUSTOMER_SERVICE = 'https://work.weixin.qq.com/kfid/kfc7323cee2a85b0bf7',
}

// 折扣优惠券大小
export const DISCOUNT_RATE_NAME = {
  0.5: '五',
  0.7: '七',
}

// 功能无卡模式上线时间
export const FUNCTION_LAUNCH_TIME = '2024-05-08 14:00:00'

export enum SCREEN_PRAMS {
  SM = 1440,
  MD = 1960,
  GPU_ITEM_WIDTH = 270,
  GPU_ITEM_GAP = 20,
}
